import { render, staticRenderFns } from "./PermissionTypeManager.vue?vue&type=template&id=125ba14f&scoped=true&"
import script from "./PermissionTypeManager.vue?vue&type=script&lang=js&"
export * from "./PermissionTypeManager.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTypeManager.vue?vue&type=style&index=0&id=125ba14f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ba14f",
  null
  
)

export default component.exports